<template>
  <transition name="pa-simple-fade" @enter="handleEnter" @leave="handleLeave">
    <section class="pa-times-modal" v-if="isOpenModal">
      <div class="header" ref="header">
        <div class="logo">
          <TokeiTimesLogo />
        </div>
        <div class="lead-text">
          <p>貴方様へのお知らせ情報一覧でございます。</p>
        </div>
      </div>

      <!-- contentがスクロールされたら、Listないでhandlescrollします。 -->
      <!-- :contentHeight="mainContentHeight" -->
      <!-- :isEnableBottomBounce="isEnableListBottomBounce" -->
      <div class="content" ref="content">
        <div class="content-inner" ref="contentInner">
          <PATimesModalList
           :isOpen="isOpenList"
           :contentHeight="mainContentHeight"
          />

          <PATimesModalDetail
           :isOpen="isOpenDetail"

           @requestClose="handleClose"
          />
          
          <PATimesModalLoading
           :isOpen="isOpenLoading"
           :contentHeight="mainContentHeight"
          />
        </div>
      </div>
      
      <div class="footer" ref="footer">
        <button class="button close-button" @click.prevent="handleClose">閉じる</button>
      </div>
    </section>
  </transition>
</template>

<script>
import TokeiTimesLogo from '@/components/Parts/PATimesModal/images/tokei_times_logo.svg?inlineN'

import PATimesModalList     from '@/components/Parts/PATimesModal/Parts/PATimesModalList'
import PATimesModalDetail   from '@/components/Parts/PATimesModal/Parts/PATimesModalDetail'
import PATimesModalLoading  from '@/components/Parts/PATimesModal/Parts/PATimesModalLoading'

export default {
  components  : {
    TokeiTimesLogo,
    PATimesModalList,
    PATimesModalDetail,
    PATimesModalLoading
  },

  data(){
    return {
      isOpenList    : false,
      isOpenDetail  : false,
      isOpenLoading : false,

      mainContentHeight : 0,

      // isEnableListBottomBounce  : false

      isOpenModal           : false,
      selectedInfomationId  : null,
    };
  },

  computed    : {
    urlQuery(){
      return this.$route.query;
    },

    isLoadingModal(){
      return this.$store.state.paTimesModal.isLoadingModal;
    }
  },

  watch : {
    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        if( typeof data.times_modal_open === 'undefined' ){
          this.isOpenModal = false;
        }else{
          this.isOpenModal = true;
        }

        if( typeof data.infomation_id === 'undefined' ){
          this.selectedInfomationId = null;
        }else{
          this.selectedInfomationId = data.infomation_id;
        }
      },
      immediate: true,
      deep: true
    },

    selectedInfomationId : {
      handler(value){
        if(typeof value === 'undefined') return;

        if(value === null){
          this.isOpenList   = true;
          this.isOpenDetail = false;
        }else{
          this.isOpenList   = false;
          this.isOpenDetail = true;
        }
      },
      immediate: true
    },

    isLoadingModal(value){
      this.isOpenLoading = value;
    },

    isOpenDetail : {
      handler(){
        this.$nextTick(() => {
          this.calculateContentHeight();
        });
      },
      immediate: true
    },

    isOpenList  : {
      handler(){
        this.$nextTick(() => {
          this.calculateContentHeight();
        });
      },
      immediate: true
    }
  },

  methods     : {
    handleEnter(){
      this.$store.dispatch({
        type  : 'layouts/updateIsBodyNoScroll',
        value : true
      });

      this.isOpenList = true;

      this.$nextTick(() => {
        this.calculateContentHeight();
      });
    },

    handleLeave(){
      this.$store.dispatch({
        type  : 'layouts/updateIsBodyNoScroll',
        value : false
      });
    },

    handleClose(){
      this.isOpenList   = false;
      this.isOpenDetail = false;

      this.selectedInfomationId = null;

      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      if(typeof newUrlQuery.times_modal_open !== 'undefined'){
        delete newUrlQuery.times_modal_open;
      }

      if(typeof newUrlQuery.infomation_id !== 'undefined'){
        delete newUrlQuery.infomation_id;
      }

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    calculateContentHeight(){
      if( (typeof this.$refs.header === 'undefined') || (this.$refs.header === null) ) return;
      if( (typeof this.$refs.footer === 'undefined') || (this.$refs.footer === null) ) return;
      
      const windowHeight = window.innerHeight;

      const headerHeight = this.$refs.header.offsetHeight;

      const footerHeight = this.$refs.footer.offsetHeight;
      
      this.mainContentHeight = windowHeight - (headerHeight + footerHeight);

      this.$refs.content.style.height = this.mainContentHeight + 'px';
    }
  },

  created(){
    window.addEventListener('resize', this.calculateContentHeight);
  },

  beforeDestroy(){
    window.removeEventListener('resize', this.calculateContentHeight);
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-times-modal{
  position: fixed;
  top:0;
  left:0;
  z-index: 60;
  width: 100%;
  height: 100%;
  background:linear-gradient(0deg, rgba($body-background-primary, .95), rgba($body-background-semi-light-darker, .9));
  backdrop-filter: blur(3px) opacity(.9);
  box-sizing: border-box;

  .header{
    .logo{
      padding-top:1rem;
      text-align: center;
      
      svg{
        width:45%;

        @include from(768px) {
          max-width:250px;
        }

        .cls-1{
          fill:#540e23;
        }
        
        .cls-2{
          fill:none;
          stroke:#540e23;
          stroke-miterlimit:10;
        }
      }
    }

    .lead-text{
      text-align: center;

      background-color:#540e23;
      color:#8e6576;
      margin-top:.2rem;
      padding:3px 4px;
      user-select: none;

      p{
        @include until(375px) {
          text-align: center;
          font-size:.9rem;
        }
      }
    }
  }

  .content{
    position: relative;
    overflow-y: scroll;
  }

  .footer{
    position: fixed;
    left:0;
    bottom:0;
    z-index: 60;
    width:100%;
    margin:0;
    padding:0;
    background-color: #6D1B36;
    color:#cccccc;
    text-align: center;
    cursor: pointer;

    button.button{
      display: block;
      width:100%;
      margin: 0 auto;
      padding:.6rem .2rem;
      font-size: 1.2rem;
      margin-bottom:env(safe-area-inset-bottom);
      border:0;
      border-radius: 0;
      text-align: center;
      color:#cccccc;
      background-color: #6D1B36;
    }
  }
}
</style>
